import { motion } from "framer-motion";
import { SplitLines } from "../motion/SplitLines";
import { EASE } from "../motion/Reveal";

/**
 * Editorial page header: eyebrow on the left column, kinetic masked headline,
 * optional lede on the right column (asymmetric 12-col grid).
 */
export const PageHeader = ({ eyebrow, lines, lede, aside, testId }) => (
  <section data-testid={testId} className="relative pt-36 pb-16 lg:pt-44 lg:pb-24">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-8">
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
            className="eyebrow"
          >
            {eyebrow}
          </motion.p>
          <SplitLines
            lines={lines}
            delay={0.2}
            className="mt-6 font-serif text-5xl leading-[1.02] tracking-tight text-ink sm:text-6xl lg:text-7xl"
          />
        </div>
        <div className="flex flex-col justify-end lg:col-span-4">
          {lede && (
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.7 }}
              className="text-base leading-relaxed text-ink-soft sm:text-lg"
            >
              {lede}
            </motion.p>
          )}
          {aside}
        </div>
      </div>
    </div>
  </section>
);
